import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { PurchasePlusBaseErrorFragmentDoc } from './BaseError.generated'
import * as Types from './purchasePlus_graphql'

export const CreatePricedCataloguedProductDocument = gql`
  mutation CreatePricedCataloguedProduct($input: CreatePricedCataloguedProductInput!) {
    createPricedCataloguedProduct(input: $input) {
      pricedCataloguedProduct {
        id
        sellUnitPrice
        sellUnitTaxPercentage
        catalogue {
          id
          title
          supplier {
            id
            name
          }
        }
        product {
          id
          image
          brand
          itemDescription
          itemSize
          itemMeasure
          itemPackName
          concatenatedSellUnit
          productCode
          pricedCatalogues {
            totalCount
          }
        }
      }
      errors {
        ...PurchasePlusBaseError
      }
    }
  }
  ${PurchasePlusBaseErrorFragmentDoc}
` as unknown as DocumentNode<
  Types.CreatePricedCataloguedProductMutation,
  Types.CreatePricedCataloguedProductMutationVariables
>
